import { CategoryObjectIds } from "../../../../application/domain/help/const";
import { Category } from "../../../../application/domain/help/help-entity";
import { Icons } from "../../../atoms/icon";
import { RichTextRender } from "../../../molecules/help/rich-text-render";
import "./notification.scss";

export const Notification: React.FC<{
  categoryList: Category[];
}> = ({ categoryList }) => {
  const category = categoryList.find(
    (category) => category.id === CategoryObjectIds.NOTIFICATION_OBJECT_ID,
  );
  return category && !!category.metadata.description ? (
    <div className="help-notification-box">
      <h2 className="help-notification-header">
        <span className="help-category-header-icon">
          <Icons.AnnouncementIcon />
        </span>
        <a id={category.title} href={`#${category.title}`}>
          {category.title}
        </a>
      </h2>
      <div className="help-notification">
        <RichTextRender html={category.metadata.description} />
      </div>
    </div>
  ) : null;
};
